<div *ngIf="isLoading | async" class="loader-overlay">
    <div class="loader"></div>
    <p class="loader-message">
      Vos documents sont en cours de chargement, merci de ne pas fermer la page.
    </p>
  </div>
  